import React, { useEffect } from "react";
import { useAuth } from "./items/AuthProvider";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
  Divider,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import request from "../services/Request";
import moment from "moment/moment";
const OrderPage = () => {
  const navigate = useNavigate();
  const { user, setLoading, loading } = useAuth();

  const [order, setOrder] = React.useState([]);

  useEffect(() => {
    setLoading(true);
    if (!user) {
      navigate("/login");
    } else {
      request({
        method: "post",
        url: `/clientUser/orders`,
        data: {
          _id: user._id,
          number: 30,
        },
      })
        .then((res) => {
          res.data.forEach((order) => {
            if (order.clientUser.points_used) {
              order.clientUser.discount_amount =
                order.clientUser.points_used / 100;
            }
          });

          console.log("orderhistory", res.data);
          setOrder(res.data);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    return () => {
      setLoading(false);
      setOrder([]);
    };
  }, []);

  return (
    <div className="page-container">
      <Box sx={{ p: 2, maxWidth: 400, margin: "auto" }}>
        <Typography variant="h4" gutterBottom>
          Order History
        </Typography>
        {order.map((order) => (
          <Card key={order.id} sx={{ mb: 2 }}>
            <CardHeader
              sx={{
                "& .MuiCardHeader-title": {
                  fontSize: "0.8rem", // Adjust the size as needed
                },
              }}
              title={`Order:${order.id}`}
              action={
                <Chip label={order.status} size="small" color="secondary" />
              }
            />
            <CardContent>
              <Typography variant="body2" color="text.secondary">
                Machine ID: {order.machineInfo?.name}
                <br />
                Name: {order.machineInfo?.description}
                <br />
                Date:{moment(new Date(order?.createdAt)).utc().format("lll")}
              </Typography>
              <Divider sx={{ my: 1 }} />
              {order.products?.map((item, index) => {
                console.log("itemdiscount", item.discount > 0);
                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      py: 1,
                    }}
                  >
                    <Box>
                      <Typography variant="body1">
                        {item?.productInfo?.name}
                      </Typography>
                      {item.discount > 0 && (
                        <Typography variant="body2" color="success.main">
                          Discount: -$
                          {item.discount.toFixed(2)}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ textAlign: "right" }}>
                      {item.discount > 0 && (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ textDecoration: "line-through" }}
                        >
                          ${(item.soldPrice + item.discount).toFixed(2)}
                        </Typography>
                      )}

                      <Typography variant="body1">
                        ${item.soldPrice.toFixed(2)}
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
              <Divider sx={{ my: 1 }} />
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography>Subtotal</Typography>
                <Typography>
                  $
                  {(
                    order.total -
                      order.tax +
                      order.clientUser?.discount_amount || 0
                  ).toFixed(2)}
                </Typography>
              </Box>
              {order.clientUser?.discount_amount > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    color: "success.main",
                  }}
                >
                  <Typography>Discount</Typography>
                  <Typography>
                    -${order.clientUser?.discount_amount?.toFixed(2) || 0}
                  </Typography>
                </Box>
              )}

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography>Tax</Typography>
                <Typography>${order.tax.toFixed(2)}</Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "bold",
                }}
              >
                <Typography variant="subtitle1">Total</Typography>
                <Typography variant="subtitle1">
                  ${order.total.toFixed(2)}
                </Typography>
              </Box>

              {/* New Points Section */}
              <Divider sx={{ my: 1 }} />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: "primary.main",
                }}
              >
                <Typography>Points Gained</Typography>
                <Typography>
                  +{order.clientUser?.points_gained?.toFixed(0) || 0}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: "error.main",
                }}
              >
                <Typography>Points Used</Typography>
                <Typography>
                  -{order.clientUser?.points_used?.toFixed(0) || 0}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  color: "primary.main",
                }}
              >
                <Typography>Points Left</Typography>
                <Typography>
                  {order.clientUser?.points_total?.toFixed(0) || 0}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </div>
  );
};

export default OrderPage;
